import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ReportsService } from "./ReportsService";

export const ListTransaction = createAsyncThunk(
    "ls/ListTransaction",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().ListTransaction(
            payload
        );
        return response?.data;
      } catch (error) {
        return error?.response;
      }
    }
);

export const AgentListTransaction = createAsyncThunk(
    "ls/ListTransaction",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response =
            await ReportsService.reportsModule().AgentListTransaction(payload);
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const MainWalletReport = createAsyncThunk(
    "ls/MainWalletReport",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().MainWallet(payload);
        return response?.data;
      } catch (error) {
        return error?.response;
      }
    }
);

export const MainWalletdownline = createAsyncThunk(
    "ls/MainWalletdownline",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().MainWalletDownline(
            payload
        );
        return response?.data;
      } catch (error) {
        return error?.response;
      }
    }
);

export const CommissionWalletReport = createAsyncThunk(
    "ls/CommissionWalletReport",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response =
            await ReportsService.reportsModule().CommissionWalletReport(payload);
        return response?.data;
      } catch (error) {
        return error?.response;
      }
    }
);

export const CusstomerListing = createAsyncThunk(
    "ls/CusstomerListing",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().CusstomerListing(
            payload
        );
        return response?.data;
      } catch (error) {
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const SingleCustomerListing = createAsyncThunk(
    "ls/SingleCustomerListing",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response =
            await ReportsService.reportsModule().SingleCustomerListing(payload);
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const TransactionSummary = createAsyncThunk(
    "ls/TransactionSummary",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().TransactionSummary(
            payload
        );
        return response?.data;
      } catch (error) {
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const AirtimeReports = createAsyncThunk(
    "ls/AirtimeReports",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().AirtimeReports(
            payload
        );
        return response?.data;
      } catch (error) {
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const BillsReports = createAsyncThunk(
    "ls/AirtimeReports",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().BillsReports(
            payload
        );
        return response?.data;
      } catch (error) {
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const DataReports = createAsyncThunk(
    "ls/DataReports",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await ReportsService.reportsModule().DataReports(
            payload
        );
        console.log(response);
        return response?.data;
      } catch (error) {
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const TransactionRecieptSummary = createAsyncThunk(
    "ls/TransactionReciept",
    async (payload) => {
      try {
        const response =
            await ReportsService.reportsModule().GetTransactionReciept(payload);
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        return error?.response;
      }
    }
);

export const ReportsSlice = createSlice({
  name: "Reports",
  initialState: "",
  extraReducers: {
    [DataReports.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [DataReports.fulfilled]: (state, action) => {
      return {
        ...state,
        DataListReports: action.payload,
        loading: false,
      };
    },
    [DataReports.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [BillsReports.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [BillsReports.fulfilled]: (state, action) => {
      return {
        ...state,
        BillsListReports: action.payload,
        loading: false,
      };
    },
    [BillsReports.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [AirtimeReports.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AirtimeReports.fulfilled]: (state, action) => {
      return {
        ...state,
        AirtimeReports: action.payload,
        loading: false,
      };
    },
    [AirtimeReports.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ListTransaction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListTransaction.fulfilled]: (state, action) => {
      return {
        ...state,
        TransactionListingReport: action.payload,
        loading: false,
      };
    },
    [ListTransaction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [MainWalletReport.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [MainWalletReport.fulfilled]: (state, action) => {
      return { ...state, MainWalletReport: action.payload, loading: false };
    },
    [MainWalletReport.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [MainWalletdownline.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [MainWalletdownline.fulfilled]: (state, action) => {
      return { ...state, MainWalletdownline: action.payload, loading: false };
    },
    [MainWalletdownline.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CommissionWalletReport.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CommissionWalletReport.fulfilled]: (state, action) => {
      return { ...state, CommissionReport: action.payload, loading: false };
    },
    [CommissionWalletReport.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [SingleCustomerListing.pending]: (state) => {
      return {
        ...state,
        loadingCustomer: true,
      };
    },
    [SingleCustomerListing.fulfilled]: (state, action) => {
      return {
        ...state,
        SingleCustomer: action.payload,
        loadingCustomer: false,
      };
    },
    [SingleCustomerListing.rejected]: (state, action) => {
      return {
        ...state,
        loadingCustomer: false,
        error: action.payload,
      };
    },

    [CusstomerListing.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CusstomerListing.fulfilled]: (state, action) => {
      return {
        ...state,
        CusstomerListingReport: action.payload,
        loading: false,
      };
    },
    [CusstomerListing.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [TransactionSummary.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [TransactionSummary.fulfilled]: (state, action) => {
      return {
        ...state,
        TransactionSummaryReport: action.payload,
        loading: false,
      };
    },
    [TransactionSummary.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [TransactionRecieptSummary.pending]: (state) => {
      return {
        ...state,
        Reciept: {},
        loading: true,
      };
    },
    [TransactionRecieptSummary.fulfilled]: (state, action) => {
      return {
        ...state,
        Reciept: action.payload,
        loading: false,
      };
    },
    [TransactionRecieptSummary.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        Reciept: {},
        error: action.payload,
      };
    },
  },
});

export default ReportsSlice.reducer;
